<script>
  import { onMount, afterUpdate } from "svelte";
  import { baseUrl, getUrlVars } from "../../scripts/loadExternalData";


  export const state = {
    title: "",
    htmlText: "",
    type: "",
  };

  export let graphicTitle = '';

  onMount(() => {
    window.addEventListener("resize", () => postRatio());

    setupLiveData();
    fetchGraphicData();
    postRatio();
  });

  afterUpdate(() => {
    postRatio();
  })

  function postRatio() {
    const containerElement = document.getElementsByTagName("body")[0];

    window.parent.postMessage(
      {
        ratio: containerElement.offsetHeight / window.innerWidth,
        location: window.location.href,
      },
      "*"
    );
  }

  function setupLiveData() {
    window.addEventListener("message", (ev) => {
      if (!ev.data.key || !ev.data.value) return;

      const { key, value } = ev.data;

      state[key] = value;
    });
  }

  function fetchGraphicData() {
    fetch(`${baseUrl}/fields/${getUrlVars().id}`)
      .then((data) => data.json())
      .then(({ fields, title }) => {
        graphicTitle = title;
        
        for (let name in state) {
          if(!fields.find(({ key }) => key === name)) return;

          state[name] = fields.find(({ key }) => key === name).value;
        }
      });
  }
</script>

<style>
  .factbox-wrapper {
    max-width: 520px;
  }

    .factbox-title-no-image {
    vertical-align: top;
    border-top: 1px solid #ddd;
    letter-spacing: 0.5px;
    font-family: DNSans, Georgia, "Times New Roman", Times, serif;
    font-weight: 700;
    font-size: 20px;
    line-height: 20px;
    padding-left: 10px;
    letter-spacing: 0.5px;
    max-height: 88px;
    padding-top: 10px;
    border-left: 3px solid #DA010C;
  }

  .factbox-title-no-image > span {
    color: #DA010C;
  }

  @media screen and (min-width: 520px) {
      .factbox-title-no-image {
        line-height: 24px;
      }
    }

  @media screen and (max-width: 414px) {
      .factbox-title-no-image {
        font-size: 18px;
      }
    }

  .factbox-description {
    font-family: DNSans, Georgia, "Times New Roman", Times, serif;
    background-color: white;
    position: relative;
    font-size: 16px;
    overflow-wrap: break-word;
    line-height: 1.5;
    letter-spacing: normal;
    hyphens: manual;
    font-size-adjust: 100%;
    padding-left: 10px;
    padding-top: 8px;
    margin-bottom: 0;
    margin-top: 0;
    border-left: 3px solid #DA010C;
  }

  .factbox-description > span {
    display: inline-block;
    margin-bottom: 10px;
    color: #222;
  }
</style>

<main>
  <div class='factbox-wrapper'>
    <div class='factbox-title-no-image'>
      <span>{state.type}.</span> {@html state.title}
    </div>
    
    <div class='factbox-description'>
      <span>{@html state.htmlText}</span>
    </div>
</div>
</main>